export const environment = {
	production: true,
	apiUrl: '/api',
    pusherKey: 'isup897078688e2dd04dff4b23613225',
	sentryDSN: null,
		socketUrl: "dashboard.isupport.lu",

	CLOUD_URL: null,
};
